import moment from 'moment';
import _ from 'lodash';
import { integrationsByCategory } from 'shared/core/constants/integrations';
export var formatBirthdayForRewards = function(dateString) {
    var date = moment(dateString, [
        'MM-DD-YYYY',
        'YYYY-MM-DD',
        'MM/DD/YYYY'
    ]);
    if (date.isValid()) {
        return date === null || date === void 0 ? void 0 : date.format('YYYY-MM-DD');
    }
    return '';
};
export var rewardsProgramEnabled = function(cart) {
    var _cart_order;
    var rewardAdapters = _.keys(integrationsByCategory.rewards);
    var consumerDispensaryIntegrations = ((_cart_order = cart.order) === null || _cart_order === void 0 ? void 0 : _cart_order.dispensary).consumerDispensaryIntegrations;
    return !!_.find(rewardAdapters, function(adapter) {
        var _consumerDispensaryIntegrations_adapter;
        return consumerDispensaryIntegrations === null || consumerDispensaryIntegrations === void 0 ? void 0 : (_consumerDispensaryIntegrations_adapter = consumerDispensaryIntegrations[adapter]) === null || _consumerDispensaryIntegrations_adapter === void 0 ? void 0 : _consumerDispensaryIntegrations_adapter.enabled;
    });
};
